import _ from 'lodash';

// export const RATING_CATEGORIES = {
// 	AUDIO: 'Audio Quality',
// 	FOLLOWING: 'Following',
// 	CATALOG: 'Catalog Size',
// 	MARKETABILITY: 'Marketability'
// };
export const RATING_CATEGORIES = [
	'Audio Quality',
	'Following',
	'Marketability',
	'Catalog Size',
];

export const RATING_SCALE = _.range(1, 5);

export const RATING_LABELS = {
	'Audio Quality': [
		'Demo Quality or Worse',
		'Semi Professional',
		'Professional',
		'Expert'
	],
	'Following': [
		'0 - 100,000',
		'100,001 - 1,000,000',
		'100,000,001 - 10,000,000',
		'10,000,001+'
	],
	'Marketability': [
		'Low Commercial/Low Niche',
		'High Commercial/Low Niche',
		'Low Commercial/High Niche',
		'High Commercial/High Niche'
	],
	'Catalog Size': [
		'5 - 13',
		'14 - 26',
		'27 - 52',
		'53+'
	],

};

export const TIERS = {
	IN_REVIEW: 'In Review',
	NOT_APPROVED: 'Not Approved',
	TIER_1: 'Tier 1',
	TIER_2: 'Tier 2',
	TIER_3: 'Tier 3',
	TIER_4: 'Tier 4',
	TIER_5: 'Tier 5'
};
